import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import styled from "@emotion/styled";

import { useNavigate } from "react-router-dom";

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export default function CategoriesComboBox({
  label,
  categories,
  selectedCategory,
  onChange,
}) {
  const navigate = useNavigate();

  return (
    <StyledAutocomplete
      freeSolo
      disablePortal
      value={
        categories
          ? categories.find((category) => category === selectedCategory)
          : null
      }
      options={categories ? categories : []}
      getOptionLabel={(category) => category}
      isOptionEqualToValue={(option, value) => {
        return option === value || value == null;
      }}
      onInputChange={(event, newValue) => {
        onChange(newValue == null ? null : newValue);
      }}
      fullWidth
      margin="dense"
      size="small"
      renderInput={(params) => (
        <TextField {...params} label={label ? label : ""} />
      )}
    />
  );
}
